import DOMPurify from 'dompurify'
import Vue from 'vue'

const updateComponent = function (el, binding) {
    const currentValue = binding.value

    if (binding.oldValue === currentValue) {
        return
    }

    el.innerHTML = DOMPurify.sanitize(currentValue)
}

// Custom directive to sanitize HTML based on: https://github.com/LeSuisse/vue-dompurify-html/blob/v4.1.1/packages/vue-dompurify-html/src/dompurify-html.ts
Vue.directive('dompurify-html', {
    inserted: updateComponent,
    update: updateComponent,
    unbind: (element) => {
        element.innerHTML = ''
    },
})
